// Thin wrapper over the Meta Pixel snippet in index.html, mirroring
// GoogleAnalytics.js. `fbq` only exists on app.diffit.me for non-bot sessions —
// the snippet skips loading fbevents.js entirely otherwise — so this guard is
// what keeps every call site a no-op on localhost, PR previews, E2E runs and
// export-pipeline scrapes.
const send = (command, name, params) => {
  // Strip absent values so optional fields don't reach Meta as the string
  // "undefined".
  const cleaned = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null)
  );

  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(command, name, cleaned);
  }

  // Outside the fbq guard on purpose: unlike gtag, `fbq` is undefined in dev, so
  // an echo inside the guard would never fire and local call sites would be
  // unverifiable. Excluded from prod builds.
  if (import.meta.env.DEV) {
    console.log(
      '[Meta Pixel]\n\n',
      `${command} ${name}`,
      Object.keys(cleaned).length ? { ...cleaned } : ''
    );
  }
};

// One of Meta's predefined standard events (PageView, CompleteRegistration,
// Purchase, ...). Ad sets can optimize on these directly.
export function trackMetaEvent(name, params = {}) {
  send('track', name, params);
}

// A Diffit-defined event with no standard-event equivalent. Optimizing on one of
// these requires a Custom Conversion in Events Manager pointed at the name.
export function trackMetaCustomEvent(name, params = {}) {
  send('trackCustom', name, params);
}
